import { render, staticRenderFns } from "./CancelSubmitForm9.vue?vue&type=template&id=6c8e023f&scoped=true"
import script from "./CancelSubmitForm9.vue?vue&type=script&lang=ts"
export * from "./CancelSubmitForm9.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e023f",
  null
  
)

export default component.exports